import { Breadcrumbs } from "@/components/Breadcrumbs/Breadcrumbs";
import { SingletonSidebarActions } from "@/components/SingletonSidebarActions/SingletonSidebarActions";
import { TagInputEditor } from "@/components/TagInput/TagInputEditor";
import { LayoutWorkstationHeader } from "@/components/_layouts/LayoutWorkstationHeader/LayoutWorkstationHeader";
import { useIsPlanInactive } from "@/hooks/useIsPlanInactive";
import { getCurrentDealEntity } from "@/models/deal";
import { getDefaultDealDirectoryEntity } from "@/models/dealDirectory";
import { Tag } from "@/models/tag";
import { Route } from "@/paths";
import { Stack, Text } from "@mantine/core";
import { useAtomValue } from "jotai";
import { Link } from "react-router-dom";
import { ModelsList } from "./ModelsList";

export const Sidebar = () => {
  const entity = getCurrentDealEntity();
  const { inactiveElementProps } = useIsPlanInactive();

  return (
    <LayoutWorkstationHeader
      header={
        <Breadcrumbs>
          <Text
            component={Link}
            fw={600}
            to={Route.DealTracker}
            lh={1}
            c="blue"
          >
            Deal Tracker
          </Text>
        </Breadcrumbs>
      }
    >
      <Stack
        h={"100%"}
        flex={1}
        p="xs"
        justify="space-between"
        {...inactiveElementProps}
      >
        <Stack gap={"xs"}>
          <EditTags />
          <ModelsList />
        </Stack>
        <SingletonSidebarActions
          entity={entity}
          confirmationPath={Route.DealTracker}
        />
      </Stack>
    </LayoutWorkstationHeader>
  );
};

const EditTags = () => {
  const entity = getCurrentDealEntity();
  const { data: item } = useAtomValue(entity.getObserveEntityRecordAtom());

  const { data: dealDirectoryRecord } = useAtomValue(
    getDefaultDealDirectoryEntity().getObserveEntityRecordAtom(),
  );

  const tagOptions = dealDirectoryRecord?.progressStatusTags || ([] as Tag[]);

  return (
    <TagInputEditor
      label="Status"
      callToAction="Change status..."
      allowMultiple={false}
      value={item?.progressStatusTagIds || []}
      onValueChange={(value) => {
        const newVal = value;
        entity.update({
          progressStatusTagIds: newVal || null,
        });
      }}
      tagOptions={tagOptions}
      size="md"
      styles={
        {
          label: { fontSize: 14, fontWeight: 600 },
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } as any
      }
    />
  );
};
